module.exports = __webpack_public_path__ + "img/geodir-serlefin-testimonial.cfdfa4ce.png";